<template>
  <div>
    <div
      id="detail"
      style="width: 1300px; margin: 0 auto"
      v-loading.fullscreen.lock="fullscreenLoading"
      element-loading-text="处理中…… 请耐心等待"
      element-loading-spinner="el-icon-loading"
    >
      <div class="detailBox">
        <div class="left-nav" >
          <div class="titleNav">
            <div id="nav-body">
              <div class="bg_title">
                <p style="color: #fff;font-size:24px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap" :title="firstMenuName">{{ firstMenuName }}</p>
                <p style="color: #fff;font-size:14px;">DETAIL</p>
              </div>
              <div
                v-for="(item, i) in menuList"
                @click="toList(item.id,i)"
                :key="i"
                :class="activeMenuIndex==i?'activeBorder':'hoverBorder'"
                style="
                text-align: left;
                width: 200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
                :title="item.label"
              >
                <p :class="activeMenuIndex==i?'activeP':''">{{ item.lable }}</p>
  <!--              <p class="el-icon-d-arrow-right"></p>-->
                <img src="@/assets/list/active.png" alt="" style="width: 24px;height: 20px" v-if="activeMenuIndex!=i">
                <img src="@/assets/list/actived.png" alt="" style="width: 24px;height: 20px" v-else>
              </div>
            </div>
          </div>
        </div>
        <!--    <div id="nav-header">-->
        <!--      {{ firstMenuName }} <span class="en-name">NEWS11</span>-->
        <!--    </div>-->
        <!--    <div id="detail-content">-->
        <!--      <div id="left-nav">-->
        <!--        <div id="nav-body">-->
        <!--          <div-->
        <!--            :class="{ active: item.id == secondId, 'nav-every': true }"-->
        <!--            v-for="(item, i) in menuList"-->
        <!--            @click="toList(item.id)"-->
        <!--            :key="i"-->
        <!--            style="-->
        <!--              text-align: left;-->
        <!--              width: 200px;-->
        <!--              white-space: nowrap;-->
        <!--              overflow: hidden;-->
        <!--              text-overflow: ellipsis;-->
        <!--            "-->
        <!--            :title="item.label"-->
        <!--          >-->
        <!--            {{ item.lable }}-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <div id="right-content" class="rightContent">
          <div style="position: absolute;top: -30px;left:3px;color: #fffffd;cursor:pointer;">
            <span @click="$router.push({ path: '/' })">首页</span> /
            <span>{{ firstMenuName }}</span> /
            <span v-if="menuName">{{ menuName }}</span>
            <span v-else>师资队伍</span>
          </div>
          <div v-show="!showIframe && !showBadRecord" style="margin-top: 20px">
            <div id="article-header">
              {{ content.title }}
            </div>
            <div id="article-info">
              <span class="info-text">来源:{{ content.source }} ;<el-divider direction="vertical"></el-divider></span>
              <span class="info-text">作者:{{ content.author }} ;<el-divider direction="vertical"></el-divider></span>
              <span class="info-text">时间:{{ content.addDate }} ;<el-divider direction="vertical"></el-divider></span>
              <span class="info-text">点击:{{ content.hits }};</span>
            </div>
            <el-divider></el-divider>
            <div id="article-content" class="content">
              <div v-html="content.contentString" class="ql-editor"></div>
            </div>
            ​
            <div
              v-for="(item, index) in content.files"
              :key="index"
              style="width: 100%; text-align: center"
            >
              <!-- <iframe

                :src="
                  '/mainsys/cmsapi/getFilePath?fileId=' + item.id + '&password='
                "
                width="500px"
                height="280px"
              ></iframe> -->
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: center;
                  width: 100%;
                "
                v-if="
                  item.fileSuffix == '.MP4' ||
                  item.fileSuffix == '.mp4' ||
                  item.fileSuffix == 'MP4' ||
                  item.fileSuffix == 'mp4'
                "
              >
                <video width="480" height="400" controls>
                  <source
                    :src="
                      '/mainsys/cmsapi/getFilePath?fileId=' +
                      item.id +
                      '&password='
                    "
                    type="video/mp4"
                  />
                </video>
              </div>

              <iframe
                v-if="
                  item.fileSuffix == '.pdf' ||
                  item.fileSuffix == '.PDF' ||
                  item.fileSuffix == 'PDF' ||
                  item.fileSuffix == 'pdf'
                "
                :src="
                  '/mainsys/cmsapi/getFilePath?fileId=' + item.id + '&password='
                "
                width="90%"
                height="600px"
              ></iframe>
              <a
                href="#"
                @click="downloadFile(item)"
                style="display: block; width: 100%; margin: 12px 0 24px 0"
              >{{ item.fileName }}</a
              >
            </div>

            <!-- <div
              style="margin: 10px 0 0 40px;"
              v-if="content.files && content.files.length > 0"
            >
                       <span style="font-size:18px;font-weight:600;color:rgba(203,203,203,1);">附件下载</span>
              <div v-for="(item, index) in content.files">
                <a
                  :href="'/mainsys/cmsapi/getFilePath?fileId=' + item.id"
                  target="_blank"
                  >{{ item.fileName }}</a
                >
                <a href="#" @click="downloadFile(item)">{{ item.fileName }}</a>
              </div>
              <div
                v-for="(item, index) in content.files"
                v-if="item.fileSuffix != '.MP4' && item.fileSuffix != '.mp4'"
              >
                <a href="#" @click="downloadFile(item)">{{ item.fileName }}</a>
              </div>
            </div> -->
          </div>

          <div v-show="showBadRecord">
            <!--显示不良记录-->
            <el-table
              default-expand-all
              stripe
              :data="mainData"
              border
              style="width: 100%; margin-top: 30px"
              :header-cell-style="{ color: '#0B52A3', textAlign: 'center' }"
              :cell-style="{ color: '#000', textAlign: 'center' }"
            >
              <el-table-column prop="labItemName" width="150px" label="序号">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column
                prop="userName"
                width="150px"
                label="姓名"
              ></el-table-column>
              <el-table-column
                prop="time"
                min-width="180"
                label="时间"
              ></el-table-column>
              <el-table-column
                prop="deviceName"
                min-width="100px"
                label="设备名称"
              ></el-table-column>
              <el-table-column
                prop="detail"
                min-width="150px"
                label="种类"
              ></el-table-column>
              <el-table-column
                prop="detailLevel"
                min-width="150px"
                label="严重程度"
              ></el-table-column>
              <el-table-column
                prop="score"
                min-width="150px"
                label="扣除信用积分"
              ></el-table-column>
            </el-table>
          </div>
          <div v-show="showIframe">
            <iframe
              :src="url"
              style="
                width: 1100px;
                min-height: 600px;
                margin: 0px;
                padding: 0px;
                border: 0;
                overflow-y: hidden;
              "
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部快捷链接 -->
    <div class="bottomLink">
      <div style="
            margin: 0 auto;display: flex;
            align-items: center;
            justify-content: center;
            width: 1300px;
            padding: 0 5%;
            height: 60px;
">
        <div
          v-for="(item, index) in friendshipLink.res"
          :key="index"
          class="bottomLinkList"
          :style="{cursor:item.linkName == '中心服务'?'default':'pointer'}"
          @click="goLink(item)"
        >
          <div style="display:flex;align-items: center;">
            <img
              :src="'/mainsys/UserFiles/externalicon/' + item.linkImage"
              style="height: 18px;width: 18px;margin-right:12px;"
            />
            <div style="line-height: 20px;height: 20px;">
              {{ item.linkName }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- 底部版权信息 -->
    <div class="copyDiv">
      <div style="width: 1300px;margin: 0 auto;display: flex;
          justify-content: space-between;
          align-items: center;">
        <div class="copyDivLeft">
          <img
            :src="require('../assets/bottomLogo.png')"
            alt=""
            style="width:360px;height:50px;margin-bottom:16px"
          />
          <div class="copyDivLeftCon">建设单位：国防科技大学</div>
          <div class="copyDivLeftCon">支持单位：湖南强智科技发展有限公司</div>
          <div class="copyDivLeftCon">
            推荐使用: Chrome或Firefox等主流浏览器
          </div>
          <div class="copyDivLeftCon">
            Copyright © 1999- 2024 国防科技大学 版权所有
          </div>
          <div class="copyDivLeftCon">
            网站访问次数：{{websiteVisitsNum}} 次
          </div>
        </div>
        <div
          class="copyDivRight"
          style="text-align:center;width: 200px"
          v-if="friendshipLink.top && friendshipLink.top.length > 0"
        >
          <img
            :src="
              '/mainsys/UserFiles/externalicon/' +
                friendshipLink.top[0].linkImage
            "
            alt=""
            style="width:140px;height:140px;margin:0 auto;text-align: center"
          />
          <div style="font-size: 16px;color: #FAFAFA;margin-top: 16px">
            {{ friendshipLink.top[0].linkName }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "detail",
  data() {
    return {
      mainData: [],
      showBadRecord: false,
      url: "",
      showIframe: false,
      contentId: this.$route.params.contentId,
      contentIds: this.$route.params.contentIds,
      fullscreenLoading: false,
      content: {
        files: [],
      }, //内容
      firstMenuName: "",
      secondId: "",
      menuList: [],
      activeMenuIndex:0,
      menuName:"",
      websiteVisitsNum:"",
      top:0,
    };
  },
  methods: {
    goLink(item) {
      if (item.linkUrl != "/") {
        if (item.linkTarget == "_blank") {
          window.open(item.linkUrl);
        } else {
          window.location.href = item.linkUrl;
        }
      }
    },
    // 获取不良积分数据
    getTableList() {
      var fd = new FormData();
      fd.append("userId", sessionStorage.getItem("userId"));
      fd.append("pageNum", 1);
      fd.append("pageSize", 999);

      this.fullscreenLoading = true;
      axios
        .post("creditSystem/selectFlow", fd, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((response) => {
          this.mainData = response.data.data;
          this.fullscreenLoading = false;
        })
        .catch((error) => {
          this.fullscreenLoading = false;
          this.$message({
            message: "数据请求失败，请重试。",
            type: "error",
          });
        });
    },
    getContent() {
      this.fullscreenLoading = true;
      var fd = new FormData();
      fd.append("contentId", this.contentId);
      axios
        .post("/cmsapi/contents", fd, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then((response) => {
          var recData = response.data;
          this.content = recData.content;
          this.secondId = recData.secondId;
          console.log("recData", recData)
          this.menuName = recData.menuName;
          this.firstMenuName = recData.firstMenuName;
          if(this.$route.params.activeName){
            console.log(this.$route.params.activeName)
            this.menuName=this.$route.params.activeName
          }
          //如果只有一条，就把一级菜单放上。
          if (recData.secondMenu.length == 0) {
            this.menuList = [
              {
                lable: recData.firstMenuName,
                id: recData.firstMenuId,
              },
            ];
          } else {
            this.menuList = recData.secondMenu;
          }
          // if (this.content.files && this.content.files.length > 0) {
          //   this.content.files.forEach(item => {
          //     if (item.fileSuffix == ".pdf" || item.fileSuffix == ".PDF") {
          //       var fd = new FormData();
          //       fd.append("fileId", item.id);
          //       fd.append("password", "");
          //       axios
          //         .post("/cmsapi/getFilePath", fd, {
          //           headers: {
          //             "Content-Type": "application/x-www-form-urlencoded"
          //           }
          //         })
          //         .then(res => {
          //           let blob = new Blob([res.data], {
          //             type: 'application/pdf'
          //           });
          //           let fileURL = URL.createObjectURL(blob);
          //           item.src = fileURL;
          //         });
          //     }
          //     console.log(item, "item");
          //   });
          // }
          this.fullscreenLoading = false;
        })
        .catch((error) => {
          this.fullscreenLoading = false;
        });
    },
    toList: function (menuId,index) {
      this.activeMenuIndex = index;
      if(this.firstMenuName == '教学资源'){
        this.$router.push({
          path: "ListTeach:menuId",
          name: "ListTeach",
          params: { menuId: menuId,menuIndex:index },
        });
      }else{
        this.$router.push({
          path: "List:menuId",
          name: "List",
          params: { menuId: menuId,menuIndex:index },
        });
      }

    },
    downloadFile(fileItem) {
      //下载文件
      if (fileItem.password == "1") {
        //有密码
        this.$prompt("下载该附件需要密码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then((value) => {
            window.open(
              "/mainsys/cmsapi/downloadFile?fileId=" +
              fileItem.id +
              "&password=" +
              value.value
            );
          })
          .catch(() => {
            this.$message.info("取消下载");
          });
      } else {
        // var fd = new FormData();
        // fd.append("fileId", fileItem.id);
        // fd.append("password",'');
        // axios.post("/cmsapi/getFilePath", fd, {
        //   headers: { "Content-Type": "application/x-www-form-urlencoded" }
        // });
        window.open(
          "/mainsys/cmsapi/downloadFile?fileId=" + fileItem.id + "&password="
        );
      }
    },
    getCounts(){
        axios
          .post("/cmsapi/getAccessLogNum").then((res)=>{
          if(res.data.code == '2'){
            this.websiteVisitsNum = res.data.data
          }
        })
    },
    // handleScroll() {
    //   var scrollTop =
    //     window.pageYOffset ||
    //     document.documentElement.scrollTop ||
    //     document.body.scrollTop;
    //   console.log(scrollTop,'scrollTop');
    //   if (scrollTop > 100) {
    //     this.top = 1;
    //   } else {
    //     this.top = 0;
    //   }
    // },
  },
  watch: {
    $route(to, from) {
      var that = this;
    },
  //   监听滚动条
  },
  created() {


    this.getContent();
    this.getCounts()
    window.scrollTo(0, 0);
    if (this.$route.params.label == "仪器预约记录") {
      this.url = this.targetUrl + "lems/synOrderIframeRecord";
      this.showIframe = true;
    } else if (this.$route.params.label == "使用记录") {
      this.url = this.targetUrl + "lems/synUseIframeRecord/my";
      this.showIframe = true;
    } else if (this.$route.params.label == "实验室预约记录") {
      this.url = this.targetUrl + "open/MyIframeAppointment";
      this.showIframe = true;
    } else if (this.$route.params.label == "考勤记录") {
      this.url =
        this.targetUrl + "mainsys/scheduling/QueryTimetableList.jsp?type=tea";
      this.showIframe = true;
    } else if (this.$route.params.label == "实验室信息") {
      this.url = this.targetUrl + "LabOverview/getCenterIframePage/cms";
      this.showIframe = true;
    } else if (this.$route.params.label == "违规扣分处罚信息") {
      this.getTableList();
      this.showBadRecord = true;
    } else if (this.$route.params.label == "成绩查询") {
      var type = sessionStorage.getItem("schType");
      if (type == "s") {
        this.url =
          this.targetUrl +
          "mainsys/scheduling/score/NewGradeOfCourse.jsp?type=manager";
      } else {
        this.url =
          this.targetUrl +
          "mainsys/scheduling/score/NewGradeOfCourse.jsp?type=select";
      }
      this.showIframe = true;
    } else {
      this.showIframe = false;
    }
    // sessionStorage.setItem('schType',data.data.schType)
  },
  mounted(){

      this.activeMenuIndex=this.$route.params.activeIndex
      this.menuName=this.$route.params.menuName

    // let isRefresh=localStorage.getItem('isRefresh')
    // if(isRefresh=='1'){
    //   location.reload()
    //   localStorage.setItem('isRefresh','0')
    // }

  },
  beforeDestroy() {
    localStorage.setItem('isRefresh','1')
  },
};
</script>
<style scoped>
.detailBox{
  width: 1100px;
  display: flex;
  justify-content: space-between;
  min-height: 600px;
  .left-nav{
    width: 19%;
    position: relative;
    background-color: #f2f2f2;
    height: 400px;
    .bg_title{
      width: 209px;
      height: 90px;
      background: url("~@/assets/list/bg1.png") no-repeat;
      background-size: 100% 100%;
      padding: 15px 0 0 25px;
    }
  }
  .rightContent{
    width: 80%;
    position: relative;
    min-height:1000px;
  }
}
.content >>> img {
  max-width: 100%;
  margin: auto;
  height: auto;
}
.ql-editor >>> .ql-video {
  width: 700px !important;
  height: 350px !important;
}
.titleNav{
  position: absolute;
  top: -10%;
}
.activeP{
  color: #002b9e;
}
.activeBorder{
  min-height: 49px;
  border-bottom: 1px solid rgba(223,227,232,1);
  padding-left: 15px;
  font-size:18px;
  font-weight:400;
  color:rgba(128,128,128,1);
  line-height: 49px;
  cursor: pointer;
  border-left: 4px solid #002b9e;
  color: #002b9e;
}
.hoverBorder{
  min-height: 49px;
  border-bottom: 1px solid rgba(223,227,232,1);
  padding-left: 15px;
  font-size:18px;
  font-weight:400;
  color:rgba(128,128,128,1);
  line-height: 49px;
  cursor: pointer;
}
.bottomLink {
  height: 60px;
  /* width: calc(100% - 520px); */
  background: #0d3b80;
  color: #fff;
  padding: 0 260px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottomLinkList {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  position: relative;
}
.bottomLinkList:not(:last-child)::after {
  content: "";
  width: 1px;
  height: 24px;
  opacity: 0.2;
  background-color: #fff;
  position: absolute;
  right: 0;
}
.linkDivider >>> .el-divider--vertical {
  height: 24px !important;
  background-color: #3f6bae !important;
  width: 1.5px !important;
  margin: 0 30px 36px 30px !important;
}
.copyDiv {
  height: 300px;
  /* width: calc(100% - 520px); */
  padding: 45px 260px;
  background: url("../assets/bottomBg.jpg") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.copyDivLeftCon {
  opacity: 0.8;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  margin-top: 16px;
}
</style>
